<template>
  <b-breadcrumb id="crumb-container" :items="breadCrumbs()" />
</template>

<script>

import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("booking", ["getBookingNumber"]),
  },
  methods: {
    breadCrumbs() {
      if (typeof this.$route.meta.breadCrumb === "function") {
        return this.$route.meta.breadCrumb.call(this, this.$route);
      }
      if(this.$route.name === 'landing') {
        this.$route.meta.breadCrumb[0].text = `ViewTrail Home: ${this.getBookingNumber}`
      } else if (this.$route.name === 'landingauthsource'){
        this.$route.meta.breadCrumb = [{text: `ViewTrail Home: ${this.getBookingNumber}`}]
      }
      return this.$route.meta.breadCrumb;
    },
  }
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>
